import { Auth, User, onAuthStateChanged } from 'firebase/auth'
import { useEffect, useState } from 'react'
import { auth as firebaseAuth } from 'utils/firebase'

export interface UseAuthResult {
  /** The current user, or null if not authenticated */
  data: User | null
  /** Whether the auth state is still loading */
  status: 'loading' | 'success'
}

/**
 * Hook to get the current Firebase Auth instance
 * This is a simple helper that returns the auth instance
 */
export function useAuth(): Auth {
  return firebaseAuth
}

/**
 * Hook to subscribe to the current user's auth state
 * Provides real-time updates when the user signs in or out
 */
export function useUser(): UseAuthResult {
  const [user, setUser] = useState<User | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(firebaseAuth, (currentUser) => {
      setUser(currentUser)
      setLoading(false)
    })

    return () => unsubscribe()
  }, [])

  return {
    data: user,
    status: loading ? 'loading' : 'success',
  }
}
